/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { BaseComponent } from '../../index';
import { Component } from '@angular/core';
import { ErrorResponseModel, NotificationModel } from '../../../models';
import { LogService, NotifyService, UtilsService } from '../../../services';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-notification-header-wrapper',
    templateUrl: './notificationHeaderWrapper.component.html',
})

export class NotificationHeaderWrapperComponent extends BaseComponent {
    /**
     * Our notifications type array
     */
    public notification: NotificationModel;

    /**
     * Our notifications type array
     */
    public notifications: NotificationModel[] = [];

    constructor(
        private logService: LogService,
        private notifyService: NotifyService,
        private router: Router,
        private utilsService: UtilsService
    ) {
        super();

        this.setupRouteSubscriber();
        const allNotifications: NotificationModel[] = this.notifyService.getCopyOfNotifications();
        this.notifications = this.filterHeaderNotifications(allNotifications);
        this.setupNotificationSubscriber();
    }

    /**
     * Subscribe to the router to get check if we are on the notifications page.
     * @private
     */
    private setupRouteSubscriber(): void {
        this.router.events.subscribe({
            next: (event: any): void => {
                if (event instanceof NavigationEnd) {
                    this.setNotificationForView();
                }
            }
        });
    }

    /**
     * Subscriber to the notify service to get the latest notifications.
     * @private
     */
    private setupNotificationSubscriber(): void {
        this.notifyService.updateNotificationsEmitter
            .pipe(takeUntil(this.destroyed$))
            .subscribe({
                next: (notifications: NotificationModel[]): void => {
                    this.notifications = this.filterHeaderNotifications(notifications);
                    this.setNotificationForView();
                },
                error: (error: ErrorResponseModel): void => {
                    this.logService.warn('NotificationWrapperComponent: ', error.message);
                }
            });
    }

    /**
     * Set the notification variable that is used in the view.
     * @private
     */
    private setNotificationForView(): void {
        this.notification = this.notifications.length > 1
            ? this.sortHeaderNotificationsByLevel(this.notifications)[0]
            : this.notifications[0];

        if (this.notification && this.notification.level !== 1) {
            this.notification.closeButton = true;
        }
    }

    /**
     * Filter for header notifications only.
     * @param notifications
     * @private
     */
    private filterHeaderNotifications(notifications: NotificationModel[]): NotificationModel[] {
        return notifications.filter((item: NotificationModel): boolean => item.type === 'header');
    }

    /**
     * Sort the notifications by level.
     * @param headerNotifications
     * @private
     */
    private sortHeaderNotificationsByLevel(headerNotifications: NotificationModel[]): NotificationModel[] {
        return this.utilsService.sortArrayByProperty(headerNotifications, 'level');
    }
}
